import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_ORRUK_WARCLANS: {
    name: 'Battletome: Orruk Warclans (2021)',
    type: 'battletome',
  },
  ERRATA_OCTOBER_2021: {
    name: 'Errata (October 2021)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2020/07/TPxg4RtP6GEezm8N.pdf',
  },
  ERRATA_DECEMBER_2021: {
    name: 'Errata (December 2021)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2020/07/Wc8ugHhzx0x4NAV4.pdf',
  },
  ERRATA_JULY_2022: {
    name: 'Errata (July 2022)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2020/07/ZHSSm4hs7Ud0plKY.pdf',
  },
  ERRATA_OCTOBER_2022: {
    name: 'Errata (October 2022)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2020/07/koYAcRdlIdWRYJhN.pdf',
  },
  BATTLETOME_SUPPLEMENT_IRONJAWZ: {
    name: 'Batteltome Supplement Ironjawz (December 2023)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2023/09/r8DTAWmkrsW2fiRW.pdf',
  },
} satisfies TRuleSources

export default rule_sources
